module.exports = __webpack_public_path__ + "img/clothing90.5ca6ce31.jpg";